export * from './page-header/page-header.module';
export * from './stat/stat.module';
export * from './crud/crud.module';



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/index.ts